// extracted by mini-css-extract-plugin
export default {"agencies":"Agencies_agencies__x4fvq"};